//slick
// Carousel for delivery date selection

require('slick-carousel');

function slickApply(selector) {
	const $el = $(selector);

	$el.slick({
		dots: false,
		speed: 350,
		centerMode: false,
		slidesToShow: 4,
		infinite: false,
		responsive: [
			{
				breakpoint: 1500,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 4,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 1200,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 3,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 4,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 769,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 544,
				settings: {
					arrows: true,
					centerMode: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$el.slick('setPosition'); // Slick recalculate widths

	$el.css({
		opacity: 1,
	});
}

function selectedItemData() {
	const data = [];
	$('[id^=deliveryDate][disabled]').each(function() {
		data.push({
			id: $(this).attr('id'),
			date: $(this).data('date'),
			source: $(this).data('source'),
			cost: $(this).data('cost'),
		});
	});

	return data;
}

function updateValues() {
	const data = selectedItemData().sort((a, b) => b.cost - a.cost);

	const selectedElementIds = data.map(item => item.id);

	if (selectedElementIds.length) {
		$('[id^=deliveryDate]').each(function() {
			const priceEl = $(this).find('.difference');
			const isWithTop = data[0].id.includes(`deliveryDate-${$(this).data('source')}`);
			const cost = $(this).data('cost');
			if (!selectedElementIds.includes($(this).attr('id'))) {
				const value = cost - data[isWithTop && !!data.length > 1 ? 1 : 0].cost;
				if (value > 0) {
					priceEl.html(`(+$${value})`);
					priceEl.addClass('isRed');
					priceEl.removeClass('isGreen');
				} else {
					priceEl.html(`(${value === 0 || !isWithTop ? '' : '-'}$${isWithTop ? Math.abs(value) : 0})`);
					priceEl.addClass('isGreen');
					priceEl.removeClass('isRed');
				}
			} else {
				priceEl.html('');
				priceEl.removeClass('isRed');
				priceEl.removeClass('isGreen');
			}
		});
	}
}

function toggleCard($el) {
	$(`[id^=deliveryDate-${$el.data('source')}]`).attr('disabled', false); // Reset all
	$(`[id^=deliverySlider-${$el.data('source')}]`).removeClass('error');
	$el.attr('disabled', true); // Disabled selected date
	updateValues();
}

function watchCard() {
	$('.delivery-date-card').click(function() {
		toggleCard($(this));
	});
}

function deliveryCarousel() {
	if (!$('.delivery-dates.slick-initialized').length) {
		// on load
		slickApply('.delivery-dates');
		watchCard();
		updateValues();

		// Fix unclickable buttons on slick breakpoint change
		$('.delivery-dates').on('breakpoint', function() {
			watchCard();
		});
	}
}

module.exports = {
	deliveryCarousel: deliveryCarousel,
	selectedItemData: selectedItemData,
};
